import type { Session } from 'src/shared/session';

import { getDigitFromId } from './getDigitFromId';
import { isGuest } from './isGuest';

export function isNonGuestInVariantGroup(session: Session, threshold: number) {
	return !isGuest(session) && !!session.user && !!session.user.id && getDigitFromId(session.user.id) < threshold;
}
